import { observable, map, makeObservable } from 'mobx'
import Page from './Page'
import Question from './Question'
import moment from 'moment';
import {arrayMove} from 'react-sortable-hoc';
import i18n from 'i18next'
import MergeFields from './components/Survey/MergeFields'
import {browserHistory} from "react-router";

import PageQuestion from './Models/PageQuestion'
import SkipLogic from './Models/SkipLogic'

export default class Survey {

    // host = "dev-api.explori.com" //window.location.hostname

    @observable lang
    @observable num_questions = 0
    @observable loading = true
    @observable loadingQuestions = true
    @observable notFound = false
    @observable name = ""
    @observable venueOther = ""
    @observable wizardStage = 1
    @observable respondenttype = {value: "", label: "Select an item"}
    @observable surveytype = {value: "", label: "Select an item"}
    @observable producttype
    @observable productid = {value: "", label: "Select an item"}
    @observable survey_languages = []
    @observable languages = []
    @observable new_venues = []
    @observable countries = []
    @observable events = []
    @observable skipLogic
    @observable primarylanguage
    @observable opendate
    @observable closingdate
    @observable number_of = {value: "", label: "Select an item"}
    @observable number_ofEX = {value: "", label: "Select an item"}
    @observable country
    @observable town
    @observable venue
    @observable closed = false
    @observable cities = []
    @observable venues = []
    @observable errors = observable.map({})
    @observable pages = []
    welcomePage = null
    @observable exitPages = []
    @observable last_co_page
    @observable showFlags = false
    @observable titleLanguage = "en_GB"
    @observable editable_question = {} //new Question(this)
    @observable lastYearSurvey = { value: "", label: "Select an item" }
    @observable lastYearSurveys = []
    @observable focusProduct = false
    @observable showAdmin = false
    @observable cache_location
    @observable copyProduct = { value: "", label: "Select an item" }
    @observable copyProductExplori = { value: "", label: "Select an item" }
    @observable timeout = 10
    @observable copying = false
    @observable showBranchBanner = false
    @observable metadata = observable.map({})
    @observable displaySettings = observable.map({})
    @observable console = observable.map({
        kioskSettings: observable.map({})
    })
    pageQuestions = {}
    includeQuestions = true

    @observable hasMandatoryQuestions = false

    mergeFields = new MergeFields()

    num_visitors = [
        { value: 250, label: "Less than 500"},
        { value: 500, label: "500 - 1,000"},
		{ value: 1500, label: "1,000 - 2,000"},
		{ value: 2500, label: "2,000 - 3,000"},
		{ value: 4000, label: "3,000 - 5,000"},
		{ value: 6250, label: "5,000 - 7,500"},
		{ value: 8750, label: "7,500 - 10,000"},
		{ value: 12500, label: "10,000 - 15,000"},
		{ value: 20000, label: "15,000 - 25,000"},
		{ value: 37500, label: "25,000 - 50,000"},
		{ value: 75000, label: "50,000 - 100,000"},
		{ value: 100000, label: "More than 100,000"}
    ]

    respondent_type_options = {
        EV: [
            {value: "VI", label: i18n.t('respondentType.EV.VI') },
            {value: "EX", label: i18n.t('respondentType.EV.EX') },
            {value: "PR", label: i18n.t('respondentType.EV.PR') },
            {value: "NN", label: i18n.t('respondentType.EV.NN') },
        ],
        PU: [
            { value: "PURE", label: i18n.t('respondentType.PU.PURE') },
            { value: "PUAD", label: i18n.t('respondentType.PU.PUAD') },
            { value: "NN", label: i18n.t('respondentType.PU.NN') }
        ],
        VA: [
            { value: "VAVI", label: i18n.t('respondentType.VA.VAVI') },
            { value: "NN", label: i18n.t('respondentType.VA.NN')}
        ],
        EXPO: [
            { value: "VIPO", label: i18n.t('respondentType.EXPO.VIPO') },
            { value: "MYST", label: i18n.t('respondentType.EXPO.MYST') },
            { value: "EXOT", label: i18n.t('respondentType.EXPO.EXOT') },
        ]
    }

    cache_locations = [
        { value: "MySQL", label: "MySQL (default)" },
        { value: "couchbase", label: "Couchbase" },
        { value: "none", label: "None" },
        { value: "mysql_def", label: "MySQL Deferred (cache updates when scheduled task runs)" }
    ]

    survey_type_options = {
        EV: [
            {value: "PE", label: i18n.t('surveyType.EV.PE')},
            {value: "GE", label: i18n.t('surveyType.EV.GE')},
        ],
        PU: [
            {value: "PE", label: i18n.t('surveyType.PU.PE')},
            {value: "GE", label: i18n.t('surveyType.PU.GE')},
        ],
        VA: [
            {value: "PE", label: i18n.t('surveyType.VA.PE')},
            {value: "GE", label: i18n.t('surveyType.VA.GE')},
        ]
    }

    surveyOptionsTranslated = false
    respondentOptionsTranslated = false

    constructor(store) {
        makeObservable(this)
        this.store = store
        this.host = store.host
        this.industryCode = store.urlSearch.code

        //this.initSurvey()
        // .then(() => {
        //     console.log("SURVEY INIT FINISHED")
        // }).catch((e) => console.log(e))
    }

    getPageIndex = (page) => {
        let index = -1
        let offset = 0
        switch (page.pageType) {
            case 'ST':
                index = this.pages.findIndex((stardardPage) => stardardPage.id === page.id)
                break
            default:
                index = this.exitPages.findIndex((exitPage) => exitPage.id === page.id)
                offset = this.pages.length
                break
        }
        
        return (index === -1) ? -1 : (index + offset + 1)
    }

    getSurveyTypeOptions = () => {
        console.log('getSurveyTypeOptions')
        const that = this
        const options = this.survey_type_options[this.industryCode]
        if (!this.surveyOptionsTranslated) {
            options.forEach((option) => {
                option.label = i18n.t(`surveyType.${that.industryCode}.${option.value}`)
            })
            this.surveyOptionsTranslated = true
        }
        return options
    }

    preventDrag = () => {
        return this.closed
    }

    getRespondentTypeOptions = () => {
        const that = this
        const options = this.respondent_type_options[this.industryCode]
        if (!this.respondentOptionsTranslated) {
            options.forEach((option) => {
                option.label = i18n.t(`respondentType.${that.industryCode}.${option.value}`)
            })
            this.respondentOptionsTranslated = true
        }
        return options
    }

    resetEditableQuestion = (store) => {
        this.editable_question = new Question({}, store, this)
        this.editable_question.language = store.lang
        this.editable_question.host = this.host
    }

    reset = () => {
        this.errors = observable.map({})
        this.name = ""
        this.respondenttype = {value: "", label: "Select an item"}
        this.surveytype = {value: "", label: "Select an item"}
        this.productid = null
        this.survey_languages = []
        this.new_venues = []
        this.pages = []
        // this.events = []
        this.primarylanguage = null
        this.opendate = null
        this.closingdate = null
        this.number_of = {value: "", label: "Select an item"}
        this.country = null
        this.town = null
        this.venue = null
        this.cities = []
        this.num_questions = 0
    }

    validateDate = (date) => {
        const dateString = moment(date).format("MM/DD/YYYY")
        let valid = !!date && dateString.match(/\d{2}\/\d{2}\/\d{4}/)
        if (valid) {
            const parts = dateString.split("/")
            valid = valid && parseInt(parts[0]) <= 12
            valid = valid && parseInt(parts[1]) <= 31
        }
        return valid
    }

    validateVenueOther = () => {
        if (this.venue && this.venue.value === -1 && this.venueOther === "") {
            this.errors.set("venueOther", (true))
        } else {
            this.errors.set("venueOther", (false))
        }
    }

    validate = () => {
        const that = this
        let has_errors = false
        this.errors = observable.map({
            name: (this.name === ""),
            respondenttype: (this.respondenttype.value === ""),
            surveytype: (this.surveytype.value === ""),
            productid: (this.productid.value === ""),
            survey_languages: (this.survey_languages.length === 0),
            primarylanguage: (!this.primarylanguage),
        })
        if (this.showEventOptions()) {
            this.errors.set("opendate",  (!this.validateDate(this.opendate)))
            this.errors.set("closingdate", (!this.validateDate(this.closingdate)))
            this.errors.set("country", (!this.country))
            this.errors.set("town", (!this.town))
            this.errors.set("venue", (!this.venue))
            this.validateVenueOther()
            if (this.respondenttype.value === "VI") {
                this.errors.set("number_of", (this.number_of.value === ""))
            } else if (this.respondenttype.value === "EX") {
                this.errors.set("number_of", (this.number_ofEX.value === ""))
            }
        }
        this.errors.forEach((value, key) => {
            has_errors |= value
        })
        return !has_errors
    }

    getPortfolioId = (productId) => {
        const that = this
        const headers = new Headers({
            authorization: "Bearer " + that.store.token
        });
        // let url = "http://" + that.host + ":3002/srv/get/portfolioid"
        // url += "?productId=" + productId
        // fetch(url, {
        //     method: 'GET',
        //     headers: headers,
        //     mode: 'cors'
        // }).then((response) => {
        //     return response.json()
        // }).then((res) => {
            // console.log("PORTFOLIOID !!!! " + res[0].portfolioId)
            that.portfolioId = 11
            // that.questionPopulated(that.store, false)
        // })
    }

    downloadCSV = () => {
        const that = this
        return new Promise((resolve, reject) => {
            const headers = new Headers({
                authorization: "Bearer " + that.store.token
            });
            fetch("http://" + that.store.nodeGateway + "/csv/questionCsvDownload/" + that.id + "/" + that.lang.value, {
                method: 'GET',
                headers: headers,
                mode: 'cors'
            }).then((response) => {
                const status = response.status
                console.log("Response status " + status)
                if (status >= 200 && status <= 300) {
                    return response
                } else {
                     const error = {
                         message: "bad request"
                     }
                     if (status === 500) {
                         error.message = "Server error"
                     } else if (status === 404) {
                         response.json()
                         .then((msg) => {
                             error.message = msg.name + ": " + msg.detail
                         })
                     }
                     throw error
                }
            }).then((response) => {
                return response.text()
            }).then((res) => {
                const url = "http://" + that.store.nodeGateway + "/csv/questionCsvDownload/" + that.id
                resolve(url)
            }).catch((e) => {
                console.log(e)
                // that.store.addNotification(null, "Failed to generate CSV", "error")
                resolve(false)
            })
        })
    }

    surveyExists = (surveyId, cb) => {
        this.store.http.get("/api/survey/" + surveyId)
            .then((res) => {
                this.notFound = (res.name === "NotFound")
                cb()
            })
            .catch((e) => console.log(e))
    }

    getQuestionLabel = (pageQuestionId) => {
        return 'test' //this.pageQuestions[pageQuestionId].getLabel()
    }

    getConditionLabel = (condition) => {
        console.log("getconditionlabel " + JSON.stringify(condition))
        return 'test' //this.pageQuestions[condition.pageQuestionId].getSkipLabel(this, condition.set1, condition.set2)
    }

    updateWelcome(lang_code) {
        return new Promise((resolve, reject) => {
            const that = this
            console.log("welcomeText " + that.id)
            const endpoint = "/api/survey/" + that.id + "/welcomeText"
            const body = JSON.stringify({
                langcode: lang_code,
                text: that.content[lang_code].ABOVETEXT.text,
            })
            that.store.http.put(endpoint, body)
                .then(resolve)
                .catch(reject)
        })
    }

    copySkipLogic(logic) {
        return new SkipLogic(logic, this.store)
    }

    newShowIf(pageQuestion) {
        const skipLogic = new SkipLogic({
            action: {
                kind: 'ShowQuestion',
                pageQuestionId: pageQuestion.id

            },
            triggerGroups: [{
                children: [],
                interGroupLogicalOperator: 'OR'
            }]
        }, this.store)
        return skipLogic
    }

    newPageToPage(pageId, targetPageId) {
        const skipLogic = new SkipLogic({
            action: {
                kind: 'PageToPage',
                pageId: pageId

            },
            trigger: {
                condition: {
                    kind: 'CurrentPage',
                    pageId: targetPageId,
                    equalityOperator: 'Eq'
                }
            }
        }, this.store)
        return skipLogic
    }

    newSkipToPage(pageId, pageQuestionId, set1) {
        const skipLogic = new SkipLogic({
            action: {
                kind: 'SkipToPage',
                pageId: pageId

            },
            triggerGroups: [
                {
                    children: [
                        {
                            triggers: [
                                {
                                    condition: {
                                        kind: 'QuestionOptionExistsInSurveyResponse',
                                        pageQuestionId: pageQuestionId,
                                        set1: set1,
                                        equalityOperator: 'Eq'
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }, this.store)
        return skipLogic
    }

    populate = async (survey_id, store, cb) => {
        var that = this
        console.log("populate " + survey_id)
        console.log(store.surveyTab)
        try {
            let res = null
            if (store.surveyTab === 'setup' || !store.surveyTab) {
                res = await store.http.get("/api/survey/" + survey_id)
            } else {
                const asdf = await store.http.get("/survey/" + survey_id)
                res = asdf.survey
            }
            this.notFound = false
            if (res.name === "NotFound") {
                this.notFound = true
                return
            }
            that.reset()
            console.log(that.store.clientLanguages)
            const default_lang = res.metadata.defaultLocale
            that.id = res.id
            // that.skipLogic = res.skipLogic
            that.store.clientLanguages.forEach((lang) => {
                const obj = { value: lang.langcode, label: lang.langValue}
                if (obj.value === default_lang) {
                    that.primarylanguage = obj
                    that.lang = obj
                    store.changeLanguage(obj)
                }
                if (res.metadata.locales.indexOf(lang.langcode) > -1) {
                    that.survey_languages.push(obj)
                }
            })
            that.content = res.content
            that.name = res.content.title[that.primarylanguage.value].text
            that.closingdate = moment(res.metadata.productInfo.industrySpecificInfo.endDate)
            that.opendate = moment(res.metadata.productInfo.industrySpecificInfo.startDate)
            that.surveyParams = res.params
            if (res.params) {
                res.params.forEach((param) => {
                    switch (param.key) {
                        case "num_visitors":
                            that.number_of = that.num_visitors.find((obj) => obj.value === param.intValue)
                            break
                    }
                })
            }
            that.industryCode = res.metadata.productInfo.industrySpecificInfo.industry
            let surveyType = that.getSurveyTypeOptions().find((surveytype_obj) => {
                return surveytype_obj.value === res.metadata.taxonomy.surveyType
            })
            if (surveyType !== undefined) {
                that.surveytype = surveyType
            }
                
            let respondentType = that.getRespondentTypeOptions().find((respondenttype_obj) => {
                return respondenttype_obj.value === res.metadata.taxonomy.respondentType
            })
            if (respondentType !== undefined) {
                that.respondenttype = respondentType
            }
            console.log("!!!")
            const productId = false
            console.log("PRODUCT!!!! " + productId + ", " + res.metadata.productInfo.productId)
            that.productid = res.metadata.productInfo.productId
            if (productId) {
                that.productid = productId
            }

            // that.getPortfolioId(res.metadata.productId)
            that.mergeFields = res.metadata.mergeFields
            that.producttype = res.metadata.productInfo.industrySpecificInfo.productType
            that.productName = res.metadata.productInfo.industrySpecificInfo.productName
            that.cache_location = that.cache_locations.find((location) => {
                return location.value === res.metadata.cacheLocation
            })
            that.welcomePage = new Page({
                id: '1',
                pageType: 'welcome'
            }, that.store, that/*"welcome", null, null, [], that, res.content, store*/)
            that.questions = 0
            that.questionsPopulated = 0
            res.pages.forEach((page, index) => {
                
                that.questions += page.questions ? page.questions.length : 0
                if (Object.hasOwnProperty.call(page, "questions")) {
                    that.num_questions += page.questions.length
                }

                const surveyPage = new Page(page, that.store, that)

                surveyPage.skipToPageLogic.survey = that
                surveyPage.skipToPageLogic.store = that.store

                if (surveyPage.pageType === 'ST') {
                    that.pages.push(surveyPage)
                } else {
                    that.exitPages.push(surveyPage)
                    if (surveyPage.pageType === 'CO') {
                        that.last_co_page = that.exitPages.map(page => page.pageType).lastIndexOf('CO')
                    }
                }
            })
            that.skipLogic = res.skipLogic.map(logic => new SkipLogic(logic, store))
            that.skipLogic.forEach((logic) => {
                console.log(`popoulate skiplogic action ${JSON.stringify(logic.action)}`)
            })
            
            store.mode = (that.questionsPopulated !== that.questions) ? "loading" : "ready"
            this.populateMetadata(res.metadata)
            if (this.metadata.get("adminConsoleEnabled")) {
                this.populateConsole(res.metadata.console)
            }

            const data = await store.http.get('/refcode/country')
            that.countries = data.response.reduce((arr, { description, name }) => {
                arr.push({
                    value: name,
                    label: description,
                })
                return arr
            }, [])
            console.log("????")
            console.log(that.countries)
            // that.countries = asdf
            if (res.metadata.productInfo.industrySpecificInfo.venueId) {
                this.getVenue(res.metadata.productInfo.industrySpecificInfo.venueId)
            }
            
            this.populateDisplaySettings(res.metadata.displaySettings)
            this.getRespondentTypeOptions()
            this.getSurveyTypeOptions()
            this.loading = false
            cb(res)
        } catch(e) {
            console.error(e)
            store.handleError({ body: e.message, level: 'error' })
            store.failedToLoadSurvey = true
        }
    }

    getPrintLink = () => {
        return "/survey/" + this.id + "/print/?langcode=" + this.lang.value
    }

    getPreviewLink = () => {
        let protocol = window.location.protocol
        let link = window.location.hostname.split(".")
        if (link[0].match(/dev|qa/)) {
            link[0] = `surveys.${link[0]}`
        } else {
            link[0] = 'surveys'
        }
        return `${protocol}//${link.join('.')}/?surveyUuid=${this.id}&noCache=1`
    }

    populateMetadata = (res) => {
        this.metadata.set("isTest", res.isTest)
        this.metadata.set("adminConsoleEnabled", res.adminConsoleEnabled)
        this.metadata.set("prePopulated", res.prePopulated)
        this.metadata.set("status", res.status)
        this.closed = (new Date(res.closeDate).getTime() <= new Date().getTime())
        if (this.closed) {
            this.metadata.set("status", { name: "Closed"})
        }
        this.metadata.set("closeDate", moment(res.closeDate))
        this.metadata.set("clientId", res.clientId)
    }

    populateConsole = (res) => {
        const kioskSettings = this.console.get("kioskSettings")
        this.console.set("showLoginOnLoad", res.showLoginOnLoad)
        this.console.set("password", res.password)
        kioskSettings.set("showRestartButtonAfterTime", res.kioskSettings.showRestartButtonAfterTime)
        kioskSettings.set("showRestartPopupAfterTime", res.kioskSettings.showRestartPopupAfterTime)
        kioskSettings.set("redirectAfterTime", res.kioskSettings.redirectAfterTime)
        kioskSettings.set("redirectAfterTimeOnCompletion", res.kioskSettings.redirectAfterTimeOnCompletion)
        kioskSettings.set("showChooseLanguagePage", res.kioskSettings.showChooseLanguagePage)
    }

    populateDisplaySettings = (res) => {
        this.displaySettings.set("disableMobileDisplayMode", res.disableMobileDisplayMode)
        this.displaySettings.set("bannerUrl", res.bannerUrl)
        this.displaySettings.set("showPreviewMessage", res.showPreviewMessage)
        this.displaySettings.set("showBackButton", res.showBackButton)
        this.displaySettings.set("showProgressBar", res.showProgressBar)
        // this.displaySettings.set("styling", res.styling)
    }

    /**
     * Survey Wizard/Settings
     */

    getYear = () => {
        const { metadata } = this
        const { productInfo, closeDate } = metadata
        const { industrySpecificInfo } = productInfo
        const { endDate } = industrySpecificInfo
        return new Date(endDate || closeDate).getFullYear()
    }

    closeSurvey = (store) => {
        this.metadata.set("closeDate", moment())
        let date = new Date()
        date.setSeconds(0)
        console.log(date)
        this.updateSettings({
            closeDate: date.getTime()
        })
        this.metadata.set("status", { name: "Closed"})
        store.surveyCloseConfirm = false
    }

    updateSettings = (json) => {
        this.store.http.put("/api/survey/" + this.id + "/settings", JSON.stringify(json))
            .then((response) => {
                if (response.match(/Survey settings updated/)) {
                    this.store.addNotification({ body: i18n.t('settings.notification.success'), level: 'success' })
                } else {
                    this.store.handleError({ body: response, level: 'error' })
                }
            }).catch((e) => {
                console.log(e)
                this.store.handleError({ body: i18n.t('settings.notification.error"'), level: 'error' })
            })
    }

    mapToJS = (map) => {
        let obj = {}
        map.forEach((value, key) => {
            if (value instanceof Map) {
                obj[key] = toJS(value)
            } else {
                obj[key] = value
            }
        })
        return obj
    }

    updateConsole = () => {
        this.updateSettings({
            adminConsoleEnabled: this.metadata.get("adminConsoleEnabled"),
            consoleSettings: this.mapToJS(this.console.toJS())
        })
        // console.log(this.console)
        // console.log(this.console.toJS() instanceof Map)
        // console.log(JSON.stringify(this.mapToJS(this.console.toJS()), null, 4))
    }

    updateDisplaySettings = () => {
        this.updateSettings({
            displaySettings: this.mapToJS(this.displaySettings.toJS())
        })
    }

    updateTitle = () => {
        this.content.title[this.titleLanguage].text = this.name
        this.updateSettings({
            title: this.name
        })
    }

    saveProductInfo = () => {
        var json = {
            productInfo: {
                productId: this.productid,
                industrySpecificInfo: {
                    industry: this.industryCode,
                    productType: this.producttype,
                    productName: this.respondenttype.label,
                }
            }
        }

        if (this.showEventOptions() || this.showPeriod()) {
            json.productInfo.industrySpecificInfo.startDate = new Date(this.opendate).getTime()
            json.productInfo.industrySpecificInfo.endDate = new Date(this.closingdate).getTime()
        }
        if (this.showEventOptions()) {
            json.productInfo.industrySpecificInfo.venueId = this.venue.value
        }

        this.updateSettings(json)
    }

    saveLanguages = () => {
        const langs = this.survey_languages.reduce((arr, lang) => {
            arr.push(lang.value)
            return arr
        }, [])
        console.log("saving languages")
        this.updateSettings({
                locales: langs
        })
    }
    
    changeCountry = (obj) => {
        const survey = this
        console.log("changeCountry")
        survey.country = obj || undefined
        if (survey.country !== undefined) {
            survey.getCities(obj.value)
        } else {
            survey.cities = []
        }
        this.changeCity()
        this.validateCountry()
        
    }

    validateCountry = () => {
        this.errors.set("country", (!this.country))
    }
    
    getVenue = (venueId) => {
        const that = this
    }

    getVenues = async (city) => {
        const that = this
        let url = '/venues'
        url += `?city=${city}`
        url += `&active=1`
        url += '&addOther=true'
        url += `&country=${this.country.value}`
        const venues = await this.store.http.get(url)
        that.venues = venues.map(({name, venueId}) => ({
            label: name,
            value: venueId,
        }))
    }

    getCities = (countryCode, cb) => {
        const that = this
    }

    changeCity = (obj) => {
        console.log("changeCity")
        this.town = obj || undefined
        if (this.town !== undefined) {
            this.getVenues(obj.value)
            this.venue = undefined
        } else {
            this.new_venues = []
            this.venue = undefined
        }
        this.validateCity()
    }

    validateCity = () => {
        this.errors.set("town", (!this.town))
    }

    changeVenue = (obj) => {
        console.log("changeVenue")
        this.venue = obj
        this.validateVenue()
    }

    validateVenue = () => {
        this.errors.set("venue", (!this.venue))
    }

    townDisabled = () => {
        return this.closed || typeof this.country !== "object"
    }

    venueDisabled = () => {
        return this.closed || typeof this.town !== "object"
    }

    surveyTypeDisabled = () => {
        return this.respondenttype.value === "NN"
    }

    changeTopic = (obj) => {
        this.surveytype = obj || {value: "", label: "Select an item"}
        this.focusProduct = false
        if (this.surveytype.value === "GE") {
            this.changeCountry()
            this.opendate = null
            this.closingdate = null
            this.changeNumVisitors()
            // this.changeEvent()
        }
        this.validateSurvey()
    }

    validateSurvey = () => {
        this.errors.set("surveytype", (this.surveytype.value === ""))
    }

    validateNumberOf = () => {
        if (this.respondenttype.value === "VI") {
            this.errors.set("number_of", (this.number_of.value === ""))
        } else if (this.respondenttype.value === "EX") {
            this.errors.set("number_of", (this.number_ofEX.value === ""))
        }
    }

    changeNumVisitors = (obj) => {
        if (this.respondenttype.value === "VI") {
            this.number_of = obj || {value: "", label: "Select an item"}
        } else if (this.respondenttype.value === "EX") {
            this.number_ofEX = obj || {value: "", label: "Select an item"}
        }
        this.validateNumberOf()
        if (!this.errors.get("number_of") && this.saveOnChange) {
            let paramObj = this.surveyParams.find((obj) => obj.key === 'num_visitors')
            if (!paramObj) {
                paramObj = {
                    key: 'num_visitors'
                }
                this.surveyParams.push(paramObj)
            }
            paramObj.intValue = (this.respondenttype.value === "VI") ? this.number_of.value : this.number_ofEX.value
            this.updateSettings({
                params: this.surveyParams
            })
        }
    }
    /**
     * ????
     */

    getPage = (pageId) => {
        return this.pages.find((page) => page.id === pageId) || this.exitPages.find((page) => page.id === pageId)
    }

    getPageLabel = (pageId) => {
        // const page = this.pages.find((page) => page.id === pageId)
        return this.getPage(pageId).title
    }

    getPageLabelWithIndex = (pageId) => {
        let pageIndex = 0
        const page = this.pages.find((page, index) => {
            pageIndex = index
            return page.id === pageId
        })
        return `${i18n.t('s_page')}: ${pageIndex} - ${page.title}`
    }

    getPageQuestion = (pageId, questionId) => {
        if (pageId !== null) {
            const page = this.pages.find((page) => page.id === pageId)
            const question = page.questions.find((question) => question.questionId === questionId)
        } else {
            let question = []
            this.pages.forEach((page) => {
                question = question.concat(
                    page.questions.filter((question) => question.questionId === questionId)
                )
            })
            console.log("Questions found " + question)
            question = question[0]
        }
        return question
    }

    questionPopulated = (store, increase) => {
        let mode
        if (increase) {
            this.questionsPopulated += 1
        }
        console.log("questionPopulated " + this.questionsPopulated + " of  "+ this.questions)
        mode = (this.questionsPopulated !== this.questions) ? "loading" : "ready"
        if (mode === "ready") {
            this.setSkipLogic()
            console.log("survey ready")
        }
        store.mode = mode
    }

    findPageQuestionById = (pageQuestionId) => {
        let pageQuestion = null
        for (const pqId in this.pageQuestions) {
            const pq = this.pageQuestions[pqId]
            if (pq.id === pageQuestionId) {
                pageQuestion = pq
                break
            }
        }
        return pageQuestion
    }

    setSkipLogic = () => {}

    getPageIndexes = () => {
        return this.pages.map((page) => page.id).concat(this.exitPages.map((page) => page.id))
    }

    removePage = (page_index, type) => {
        const that = this
        let arr = type === 'ST' ? that.pages : that.exitPages
        console.log(arr, type, page_index)
        if (type !== 'ST') {
            page_index = page_index - that.pages.length
        }
        const page_id = arr[page_index].id
        const endpoint = "/api/survey/" + this.id + "/page/" + page_id
        that.store.http.delete(endpoint)
            .then((res) => {
                console.log("done")
                const new_arr = arr.reduce((arr, page) => {
                    arr.push(page)
                    return arr
                }, [])
                new_arr.splice(page_index, 1)
                if (type === 'ST') {
                    that.pages = new_arr
                    that.store.survey.refreshSkipLogic()
                    // this.skipLogic.forEach(sl => sl.pageRemoved(arr[page_index]))
                } else {
                    that.exitPages = new_arr
                    that.last_co_page = that.exitPages.map(page => page.pageType).lastIndexOf('CO')
                }
                this.store.addNotification({ body: "Page removed", level: 'success' })
            }).catch((e) => {
                console.log(e)
                this.store.handleError({ body: "Error removing page: " + e.message, level: 'error' })
            })
    }

    checkQuestionInheritance = () => {
        console.log("checkQuestionInheritance")
        let pageQuestionIds = []
        this.pages.forEach((page) => {
            const pageQuestions = []
            page.questions.forEach((question) => {
                pageQuestions.push(question.questionId)
                if (question.inheritQuestion.value !== "") {
                    if (pageQuestionIds.indexOf(question.inheritQuestion.value) === -1) {
                        console.log(pageQuestionIds, question.inheritQuestion.value)
                        page.updateQuestion(question, {
                            parentId: "00000000-0000-0000-0000-000000000000",
                        })
                        question.inheritQuestion = { label: "", value: "" }
                    }
                }
            })
            pageQuestionIds = pageQuestionIds.concat(pageQuestions)
        })
        console.log(pageQuestionIds)
    }

    movePage = (oldIndex, newIndex) => {
        const that = this
        const new_arr = arrayMove(that.pages, oldIndex, newIndex)
        that.pages = new_arr
        const endpoint = "/api/survey/" + this.id + "/page/" + that.pages[newIndex].id + "/move"
        const body = JSON.stringify({
            toPos: (newIndex+1),
        })
        that.store.http.put(endpoint, body)
            .then((res) => {
                console.log("page sorted " + oldIndex + ", " + newIndex)
                that.pages[newIndex].validateSkipToPage()
                that.checkQuestionInheritance()
            })
            .catch((e) => console.log(e))
    }

    addPage = (type, label, index) => {
        const that = this
        const priority = (index + 1) || (1 + this.pages.length + this.exitPages.length)
        const pageType = type || "ST"
        //page, store, survey
        /*
            this.id = page.id
            this.pageType = page.pageType
            this.priority = page.priority
            this.title = page.title
            this.randomize = page.randomize
            this.content = page.content
            this.questions = page.questions || []
        */
        const page = new Page({
            id: '',
            pageType: pageType,
            title: label || '',
            randomize: false,
            content: null,
            questions: [],
        }, this.store, this)
        console.log("survey addPage " + (typeof index) + " -> " + priority + " | " + label)

        const endpoint = "/api/survey/" + this.id + "/page"
        const body = JSON.stringify({
            atPos: priority,
            pageType: pageType,
            title: label || ""
        })
        that.store.http.post(endpoint, body)
            .then((res) => {
                console.log("done")
                page.host = that.host
                if (res.newPageId) {
                    page.id = res.newPageId
                    page.survey_id = that.id
                    if (typeof index !== "number") {
                        if (pageType === 'ST') {
                            that.pages.push(page)
                        } else {
                            that.exitPages.push(page)
                            if (pageType === 'CO') {
                                that.last_co_page = (that.exitPages.length - 1)
                            }
                        }
                    } else {
                        const new_arr = that.pages.slice(0)
                        new_arr.splice(priority - 1, 0, page)
                        that.pages = new_arr
                    }
                    that.max_page += 1
                }
                this.store.addNotification({ body: "Page added", level: 'success' })
            }).catch((e) => {
                console.log(e)
                this.store.handleError({ body: "Error adding page: " + e.message, level: 'error' })
            })
    }

    getNewJson = (doCopy) => {
        const content = {
            title: {},
            welcomeText: {}
        }

        content.title[this.primarylanguage.value] = {
            text: name
        }

        content.welcomeText[this.primarylanguage.value] = {
            text: 'Hello'
        }

        let json = {
            // kind: 'NewSurveyRequest',
            // content: content,
            name: this.name,
            createdBy: this.store.tokenData.userId,
            productId: this.productid.value.productId,
            clientId: this.store.tokenData.clientId,
            locales: this.survey_languages.reduce((arr, lang) => {
                arr.push(lang.value)
                return arr
            }, []),
            defaultLocale: this.primarylanguage.value,
            taxonomy: {
                surveyType: this.surveytype.value,
                respondentType: this.respondenttype.value,
            },
            industrySpecificInfo: {
                industry: this.industryCode,
                productType: this.productType,
                productName: this.productid.label,
                // venueId: "",
                // startDate: new Date(this.opendate).getTime(),
                // endDate: new Date(this.closingdate).getTime()
            }
        }

        if (doCopy && this.copyProductExplori.value !== "") {
            json.copyOf = this.copyProductExplori.value
        }

        if (doCopy && this.copyProduct.value !== "") {
            json.copyOf = this.copyProduct.value
        }

        if (this.showEventOptions() || this.showPeriod()) {
            json.industrySpecificInfo.startDate = new Date(this.opendate).getTime()
            json.industrySpecificInfo.endDate = new Date(this.closingdate).getTime()
        }
        if (this.showEventOptions()) {
            json.industrySpecificInfo.venueId = this.venue.value
        }

        return json
    }

    createNew = (doCopy, cb) => {
        const json = this.getNewJson(doCopy)
        console.log(JSON.stringify(json, null, 4))
        const endpoint = "/api/survey/new"
        const body = JSON.stringify(json)
        this.store.http.post(endpoint, body)
            .then((response) => {
                console.log(response)
                cb(response)
            })
            .catch((e) => console.log(e))
    }

    toJSON = () => {
        let json_obj = {}
        const that = this
        const on_from = this.mergeFields.on_from(this.opendate, this.closingdate)
        const onFrom = []
        const eventNext = []
        const eventDates = []
        // json_obj.name = this.name
        json_obj.content = {
            title: {},
            welcomeText: {}
        }
        const locales = this.survey_languages.reduce((arr, lang) => {
            arr.push({
                langcode: lang.value,
                lang: lang.label,
                langNative: lang.label,
            })
            onFrom.push({
                langcode: lang.value,
                text: on_from
            })
            eventNext.push({
                langcode: lang.value,
                text: that.mergeFields.eventNext(that)
            })
            eventDates.push({
                langcode: lang.value,
                text: that.mergeFields.eventDates(this.opendate, this.closingdate, lang.value)
            })
            json_obj.content.title[lang.value] = {
                text: that.name
            }
            return arr
        }, [])
        json_obj.pages = []
        json_obj.params = []
        // json_obj.metadata.closeDate = moment(new Date(this.closingdate)).format("YYYY-MM-DD") + "T00:00:00Z"
        // json_obj.metadata.openDate = moment(new Date(this.opendate)).format("YYYY-MM-DD") + "T00:00:00Z"
        json_obj.metadata = {
            branches: [],
            creationInfo: {
                createdBy: this.store.tokenData.userId
            },
            clientId: this.store.tokenData.clientId,
            productId: this.productid.value.productId,
            taxonomy: {
                surveyType: this.surveytype.value,
                respondentType: this.respondenttype.value,
            },
            locales: locales,
            defaultLocale: this.primarylanguage.value,
            //closeDate: moment().add(60, 'd').format("YYYY-MM-DD") + "T00:00:00Z",
            displaySettings: {
                bannerUrl: "",
            },
            console: {
                showLoginOnLoad: false,
                kioskSettings: {
                    disableMobileDisplayMode: false,
                    showRestartButtonAfterTime: 0,
                    showRestartPopupAfterTime: 0,
                    redirectAfterTime: 0,
                    redirectAfterTimeOnCompletion: 0,
                    showChooseLanguagePage: false
                }
            },
            productInfo: {
                productId: this.productid.value.productId,
                industrySpecificInfo: {
                    industry: this.industryCode,
                    productType: this.productType,
                    productName: this.productName,
                    startDate: new Date(this.opendate).getTime(),
                    endDate: new Date(this.closingdate).getTime(),
                    eventName: this.eventName,
                    eventYear: this.mergeFields.eventYear(this),
                    onFrom: onFrom,
                    eventDates: eventDates,
                    eventNext: eventNext
                }
            }
        }

        json_obj.skipLogic =  []

        if (this.venue) {
            json_obj.metadata.productInfo.industrySpecificInfo.venueId = this.venue.value
            json_obj.metadata.productInfo.industrySpecificInfo.eventVenue = this.venue.label
        }
            

        return json_obj
    }

    showEventOptions = () => {
        const respondentType = this.metadata.taxonomy.respondentType
        const industryCode = survey.metadata.productInfo.industrySpecificInfo.industry
        const surveyType = this.metadata.taxonomy.surveyType
        return industryCode === "EV"
            && respondentType && respondentType !== "" && respondentType !== "NN"
            && surveyType && surveyType !== "" && surveyType !== "GE"
    }

    showPeriod = () => {
        const respondentType = this.metadata.taxonomy.respondentType
        const industryCode = survey.metadata.productInfo.industrySpecificInfo.industry
        const surveyType = this.metadata.taxonomy.surveyType
        return (industryCode === "PU" || industryCode === "VA")
            && respondentType && respondentType !== "" && respondentType !== "NN"
            && surveyType && surveyType !== "" && surveyType !== "GE"
    }

    addLanguage = (lang) => {
        this.survey_languages.push(lang)
    }

    removeLanguage = (value) => {
        const index = this.survey_languages.findIndex((lang_obj) => {
            return lang_obj.value === value
        })
        if (index > -1) {
            if (typeof this.primarylanguage === "object" && this.primarylanguage.value === value) {
                this.primarylanguage = ""
            }
            this.survey_languages.splice(index, 1)
        }
    }

    languageSelected = (value) => {
        const index = this.survey_languages.findIndex((lang_obj) => {
            return lang_obj.value === value
        })
        return (index > -1)
    }

    initSurvey = () => {
        const that = this
        this.max_page = 0
        this.num_questions = 0
        return new Promise((resolve, reject) => {
            Promise.all([
                that.getSurveyFromServer(),
                // that.getEvents(),
                // that.getNumVisistors()
            ]).then((r) => {
                console.log(r)
                resolve("ok")
            }).catch((e) => {
                console.log(e)
                reject(e)
            })
        })
    }

    getSurveyFromServer = () => {
        const that = this
        return new Promise((resolve, reject) => {
            const headers = new Headers({
                authorization: "Bearer " + that.store.token
            });
            // fetch("http://" + that.host + ":3002/getSurvey", {
            //     method: 'GET',
            //     headers: headers,
            //     mode: 'cors'
            // }).then((response) => {
            //     return response.json()
            // }).then((res) => {
                console.log("success! getSurveyFromServer")
                // that.languages = res.response
                // that.countries = [{"DESCRIPTION":"UNITED KINGDOM","CODE":"GB"},{"DESCRIPTION":"UNITED STATES","CODE":"US"},{"DESCRIPTION":"AFGHANISTAN","CODE":"AF"},{"DESCRIPTION":"Ã…LAND ISLANDS","CODE":"AX"},{"DESCRIPTION":"ALBANIA","CODE":"AL"},{"DESCRIPTION":"ALGERIA","CODE":"DZ"},{"DESCRIPTION":"AMERICAN SAMOA","CODE":"AS"},{"DESCRIPTION":"ANDORRA","CODE":"AD"},{"DESCRIPTION":"ANGOLA","CODE":"AO"},{"DESCRIPTION":"ANGUILLA","CODE":"AI"},{"DESCRIPTION":"ANTARCTICA","CODE":"AQ"},{"DESCRIPTION":"ANTIGUA AND BARBUDA","CODE":"AG"},{"DESCRIPTION":"ARGENTINA","CODE":"AR"},{"DESCRIPTION":"ARMENIA","CODE":"AM"},{"DESCRIPTION":"ARUBA","CODE":"AW"},{"DESCRIPTION":"AUSTRALIA","CODE":"AU"},{"DESCRIPTION":"AUSTRIA","CODE":"AT"},{"DESCRIPTION":"AZERBAIJAN","CODE":"AZ"},{"DESCRIPTION":"BAHAMAS","CODE":"BS"},{"DESCRIPTION":"BAHRAIN","CODE":"BH"},{"DESCRIPTION":"BANGLADESH","CODE":"BD"},{"DESCRIPTION":"BARBADOS","CODE":"BB"},{"DESCRIPTION":"BELARUS","CODE":"BY"},{"DESCRIPTION":"BELGIUM","CODE":"BE"},{"DESCRIPTION":"BELIZE","CODE":"BZ"},{"DESCRIPTION":"BENIN","CODE":"BJ"},{"DESCRIPTION":"BERMUDA","CODE":"BM"},{"DESCRIPTION":"BHUTAN","CODE":"BT"},{"DESCRIPTION":"BOLIVIA, PLURINATIONAL STATE OF","CODE":"BO"},{"DESCRIPTION":"BONAIRE, SINT EUSTATIUS AND SABA","CODE":"BQ"},{"DESCRIPTION":"BOSNIA AND HERZEGOVINA","CODE":"BA"},{"DESCRIPTION":"BOTSWANA","CODE":"BW"},{"DESCRIPTION":"BOUVET ISLAND","CODE":"BV"},{"DESCRIPTION":"BRAZIL","CODE":"BR"},{"DESCRIPTION":"BRITISH INDIAN OCEAN TERRITORY","CODE":"IO"},{"DESCRIPTION":"BRUNEI DARUSSALAM","CODE":"BN"},{"DESCRIPTION":"BULGARIA","CODE":"BG"},{"DESCRIPTION":"BURKINA FASO","CODE":"BF"},{"DESCRIPTION":"BURUNDI","CODE":"BI"},{"DESCRIPTION":"CAMBODIA","CODE":"KH"},{"DESCRIPTION":"CAMEROON","CODE":"CM"},{"DESCRIPTION":"CANADA","CODE":"CA"},{"DESCRIPTION":"CAPE VERDE","CODE":"CV"},{"DESCRIPTION":"CAYMAN ISLANDS","CODE":"KY"},{"DESCRIPTION":"CENTRAL AFRICAN REPUBLIC","CODE":"CF"},{"DESCRIPTION":"CHAD","CODE":"TD"},{"DESCRIPTION":"CHILE","CODE":"CL"},{"DESCRIPTION":"CHINA","CODE":"CN"},{"DESCRIPTION":"CHRISTMAS ISLAND","CODE":"CX"},{"DESCRIPTION":"COCOS (KEELING) ISLANDS","CODE":"CC"},{"DESCRIPTION":"COLOMBIA","CODE":"CO"},{"DESCRIPTION":"COMOROS","CODE":"KM"},{"DESCRIPTION":"CONGO","CODE":"CG"},{"DESCRIPTION":"CONGO, THE DEMOCRATIC REPUBLIC OF THE","CODE":"CD"},{"DESCRIPTION":"COOK ISLANDS","CODE":"CK"},{"DESCRIPTION":"COSTA RICA","CODE":"CR"},{"DESCRIPTION":"CÃ”TE D'IVOIRE","CODE":"CI"},{"DESCRIPTION":"CROATIA","CODE":"HR"},{"DESCRIPTION":"CUBA","CODE":"CU"},{"DESCRIPTION":"CURAÃ‡AO","CODE":"CW"},{"DESCRIPTION":"CYPRUS","CODE":"CY"},{"DESCRIPTION":"CZECH REPUBLIC","CODE":"CZ"},{"DESCRIPTION":"DENMARK","CODE":"DK"},{"DESCRIPTION":"DJIBOUTI","CODE":"DJ"},{"DESCRIPTION":"DOMINICA","CODE":"DM"},{"DESCRIPTION":"DOMINICAN REPUBLIC","CODE":"DO"},{"DESCRIPTION":"ECUADOR","CODE":"EC"},{"DESCRIPTION":"EGYPT","CODE":"EG"},{"DESCRIPTION":"EL SALVADOR","CODE":"SV"},{"DESCRIPTION":"EQUATORIAL GUINEA","CODE":"GQ"},{"DESCRIPTION":"ERITREA","CODE":"ER"},{"DESCRIPTION":"ESTONIA","CODE":"EE"},{"DESCRIPTION":"ETHIOPIA","CODE":"ET"},{"DESCRIPTION":"FALKLAND ISLANDS (MALVINAS)","CODE":"FK"},{"DESCRIPTION":"FAROE ISLANDS","CODE":"FO"},{"DESCRIPTION":"FIJI","CODE":"FJ"},{"DESCRIPTION":"FINLAND","CODE":"FI"},{"DESCRIPTION":"FRANCE","CODE":"FR"},{"DESCRIPTION":"FRENCH GUIANA","CODE":"GF"},{"DESCRIPTION":"FRENCH POLYNESIA","CODE":"PF"},{"DESCRIPTION":"FRENCH SOUTHERN TERRITORIES","CODE":"TF"},{"DESCRIPTION":"GABON","CODE":"GA"},{"DESCRIPTION":"GAMBIA","CODE":"GM"},{"DESCRIPTION":"GEORGIA","CODE":"GE"},{"DESCRIPTION":"GERMANY","CODE":"DE"},{"DESCRIPTION":"GHANA","CODE":"GH"},{"DESCRIPTION":"GIBRALTAR","CODE":"GI"},{"DESCRIPTION":"GREECE","CODE":"GR"},{"DESCRIPTION":"GREENLAND","CODE":"GL"},{"DESCRIPTION":"GRENADA","CODE":"GD"},{"DESCRIPTION":"GUADELOUPE","CODE":"GP"},{"DESCRIPTION":"GUAM","CODE":"GU"},{"DESCRIPTION":"GUATEMALA","CODE":"GT"},{"DESCRIPTION":"GUERNSEY","CODE":"GG"},{"DESCRIPTION":"GUINEA","CODE":"GN"},{"DESCRIPTION":"GUINEA-BISSAU","CODE":"GW"},{"DESCRIPTION":"GUYANA","CODE":"GY"},{"DESCRIPTION":"HAITI","CODE":"HT"},{"DESCRIPTION":"HEARD ISLAND AND MCDONALD ISLANDS","CODE":"HM"},{"DESCRIPTION":"HOLY SEE (VATICAN CITY STATE)","CODE":"VA"},{"DESCRIPTION":"HONDURAS","CODE":"HN"},{"DESCRIPTION":"HONG KONG","CODE":"HK"},{"DESCRIPTION":"HUNGARY","CODE":"HU"},{"DESCRIPTION":"ICELAND","CODE":"IS"},{"DESCRIPTION":"INDIA","CODE":"IN"},{"DESCRIPTION":"INDONESIA","CODE":"ID"},{"DESCRIPTION":"IRAN, ISLAMIC REPUBLIC OF","CODE":"IR"},{"DESCRIPTION":"IRAQ","CODE":"IQ"},{"DESCRIPTION":"IRELAND","CODE":"IE"},{"DESCRIPTION":"ISLE OF MAN","CODE":"IM"},{"DESCRIPTION":"ISRAEL","CODE":"IL"},{"DESCRIPTION":"ITALY","CODE":"IT"},{"DESCRIPTION":"JAMAICA","CODE":"JM"},{"DESCRIPTION":"JAPAN","CODE":"JP"},{"DESCRIPTION":"JERSEY","CODE":"JE"},{"DESCRIPTION":"JORDAN","CODE":"JO"},{"DESCRIPTION":"KAZAKHSTAN","CODE":"KZ"},{"DESCRIPTION":"KENYA","CODE":"KE"},{"DESCRIPTION":"KIRIBATI","CODE":"KI"},{"DESCRIPTION":"KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF","CODE":"KP"},{"DESCRIPTION":"KOREA, REPUBLIC OF","CODE":"KR"},{"DESCRIPTION":"KUWAIT","CODE":"KW"},{"DESCRIPTION":"KYRGYZSTAN","CODE":"KG"},{"DESCRIPTION":"LAO PEOPLE'S DEMOCRATIC REPUBLIC","CODE":"LA"},{"DESCRIPTION":"LATVIA","CODE":"LV"},{"DESCRIPTION":"LEBANON","CODE":"LB"},{"DESCRIPTION":"LESOTHO","CODE":"LS"},{"DESCRIPTION":"LIBERIA","CODE":"LR"},{"DESCRIPTION":"LIBYA","CODE":"LY"},{"DESCRIPTION":"LIECHTENSTEIN","CODE":"LI"},{"DESCRIPTION":"LITHUANIA","CODE":"LT"},{"DESCRIPTION":"LUXEMBOURG","CODE":"LU"},{"DESCRIPTION":"MACAO","CODE":"MO"},{"DESCRIPTION":"MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF","CODE":"MK"},{"DESCRIPTION":"MADAGASCAR","CODE":"MG"},{"DESCRIPTION":"MALAWI","CODE":"MW"},{"DESCRIPTION":"MALAYSIA","CODE":"MY"},{"DESCRIPTION":"MALDIVES","CODE":"MV"},{"DESCRIPTION":"MALI","CODE":"ML"},{"DESCRIPTION":"MALTA","CODE":"MT"},{"DESCRIPTION":"MARSHALL ISLANDS","CODE":"MH"},{"DESCRIPTION":"MARTINIQUE","CODE":"MQ"},{"DESCRIPTION":"MAURITANIA","CODE":"MR"},{"DESCRIPTION":"MAURITIUS","CODE":"MU"},{"DESCRIPTION":"MAYOTTE","CODE":"YT"},{"DESCRIPTION":"MEXICO","CODE":"MX"},{"DESCRIPTION":"MICRONESIA, FEDERATED STATES OF","CODE":"FM"},{"DESCRIPTION":"MOLDOVA, REPUBLIC OF","CODE":"MD"},{"DESCRIPTION":"MONACO","CODE":"MC"},{"DESCRIPTION":"MONGOLIA","CODE":"MN"},{"DESCRIPTION":"MONTENEGRO","CODE":"ME"},{"DESCRIPTION":"MONTSERRAT","CODE":"MS"},{"DESCRIPTION":"MOROCCO","CODE":"MA"},{"DESCRIPTION":"MOZAMBIQUE","CODE":"MZ"},{"DESCRIPTION":"MYANMAR","CODE":"MM"},{"DESCRIPTION":"NAMIBIA","CODE":"NA"},{"DESCRIPTION":"NAURU","CODE":"NR"},{"DESCRIPTION":"NEPAL","CODE":"NP"},{"DESCRIPTION":"NETHERLANDS","CODE":"NL"},{"DESCRIPTION":"NEW CALEDONIA","CODE":"NC"},{"DESCRIPTION":"NEW ZEALAND","CODE":"NZ"},{"DESCRIPTION":"NICARAGUA","CODE":"NI"},{"DESCRIPTION":"NIGER","CODE":"NE"},{"DESCRIPTION":"NIGERIA","CODE":"NG"},{"DESCRIPTION":"NIUE","CODE":"NU"},{"DESCRIPTION":"NORFOLK ISLAND","CODE":"NF"},{"DESCRIPTION":"NORTHERN MARIANA ISLANDS","CODE":"MP"},{"DESCRIPTION":"NORWAY","CODE":"NO"},{"DESCRIPTION":"OMAN","CODE":"OM"},{"DESCRIPTION":"PAKISTAN","CODE":"PK"},{"DESCRIPTION":"PALAU","CODE":"PW"},{"DESCRIPTION":"PALESTINIAN TERRITORY, OCCUPIED","CODE":"PS"},{"DESCRIPTION":"PANAMA","CODE":"PA"},{"DESCRIPTION":"PAPUA NEW GUINEA","CODE":"PG"},{"DESCRIPTION":"PARAGUAY","CODE":"PY"},{"DESCRIPTION":"PERU","CODE":"PE"},{"DESCRIPTION":"PHILIPPINES","CODE":"PH"},{"DESCRIPTION":"PITCAIRN","CODE":"PN"},{"DESCRIPTION":"POLAND","CODE":"PL"},{"DESCRIPTION":"PORTUGAL","CODE":"PT"},{"DESCRIPTION":"PUERTO RICO","CODE":"PR"},{"DESCRIPTION":"QATAR","CODE":"QA"},{"DESCRIPTION":"RÃ‰UNION","CODE":"RE"},{"DESCRIPTION":"ROMANIA","CODE":"RO"},{"DESCRIPTION":"RUSSIAN FEDERATION","CODE":"RU"},{"DESCRIPTION":"RWANDA","CODE":"RW"},{"DESCRIPTION":"SAINT BARTHÃ‰LEMY","CODE":"BL"},{"DESCRIPTION":"SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA","CODE":"SH"},{"DESCRIPTION":"SAINT KITTS AND NEVIS","CODE":"KN"},{"DESCRIPTION":"SAINT LUCIA","CODE":"LC"},{"DESCRIPTION":"SAINT MARTIN (FRENCH PART)","CODE":"MF"},{"DESCRIPTION":"SAINT PIERRE AND MIQUELON","CODE":"PM"},{"DESCRIPTION":"SAINT VINCENT AND THE GRENADINES","CODE":"VC"},{"DESCRIPTION":"SAMOA","CODE":"WS"},{"DESCRIPTION":"SAN MARINO","CODE":"SM"},{"DESCRIPTION":"SAO TOME AND PRINCIPE","CODE":"ST"},{"DESCRIPTION":"SAUDI ARABIA","CODE":"SA"},{"DESCRIPTION":"SENEGAL","CODE":"SN"},{"DESCRIPTION":"SERBIA","CODE":"RS"},{"DESCRIPTION":"SEYCHELLES","CODE":"SC"},{"DESCRIPTION":"SIERRA LEONE","CODE":"SL"},{"DESCRIPTION":"SINGAPORE","CODE":"SG"},{"DESCRIPTION":"SINT MAARTEN (DUTCH PART)","CODE":"SX"},{"DESCRIPTION":"SLOVAKIA","CODE":"SK"},{"DESCRIPTION":"SLOVENIA","CODE":"SI"},{"DESCRIPTION":"SOLOMON ISLANDS","CODE":"SB"},{"DESCRIPTION":"SOMALIA","CODE":"SO"},{"DESCRIPTION":"SOUTH AFRICA","CODE":"ZA"},{"DESCRIPTION":"SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS","CODE":"GS"},{"DESCRIPTION":"SOUTH SUDAN","CODE":"SS"},{"DESCRIPTION":"SPAIN","CODE":"ES"},{"DESCRIPTION":"SRI LANKA","CODE":"LK"},{"DESCRIPTION":"SUDAN","CODE":"SD"},{"DESCRIPTION":"SURINAME","CODE":"SR"},{"DESCRIPTION":"SVALBARD AND JAN MAYEN","CODE":"SJ"},{"DESCRIPTION":"SWAZILAND","CODE":"SZ"},{"DESCRIPTION":"SWEDEN","CODE":"SE"},{"DESCRIPTION":"SWITZERLAND","CODE":"CH"},{"DESCRIPTION":"SYRIAN ARAB REPUBLIC","CODE":"SY"},{"DESCRIPTION":"TAIWAN, PROVINCE OF CHINA","CODE":"TW"},{"DESCRIPTION":"TAJIKISTAN","CODE":"TJ"},{"DESCRIPTION":"TANZANIA, UNITED REPUBLIC OF","CODE":"TZ"},{"DESCRIPTION":"THAILAND","CODE":"TH"},{"DESCRIPTION":"TIMOR-LESTE","CODE":"TL"},{"DESCRIPTION":"TOGO","CODE":"TG"},{"DESCRIPTION":"TOKELAU","CODE":"TK"},{"DESCRIPTION":"TONGA","CODE":"TO"},{"DESCRIPTION":"TRINIDAD AND TOBAGO","CODE":"TT"},{"DESCRIPTION":"TUNISIA","CODE":"TN"},{"DESCRIPTION":"TURKEY","CODE":"TR"},{"DESCRIPTION":"TURKMENISTAN","CODE":"TM"},{"DESCRIPTION":"TURKS AND CAICOS ISLANDS","CODE":"TC"},{"DESCRIPTION":"TUVALU","CODE":"TV"},{"DESCRIPTION":"UGANDA","CODE":"UG"},{"DESCRIPTION":"UKRAINE","CODE":"UA"},{"DESCRIPTION":"UNITED ARAB EMIRATES","CODE":"AE"},{"DESCRIPTION":"UNITED STATES MINOR OUTLYING ISLANDS","CODE":"UM"},{"DESCRIPTION":"URUGUAY","CODE":"UY"},{"DESCRIPTION":"UZBEKISTAN","CODE":"UZ"},{"DESCRIPTION":"VANUATU","CODE":"VU"},{"DESCRIPTION":"VENEZUELA, BOLIVARIAN REPUBLIC OF","CODE":"VE"},{"DESCRIPTION":"VIETNAM","CODE":"VN"},{"DESCRIPTION":"VIRGIN ISLANDS, BRITISH","CODE":"VG"},{"DESCRIPTION":"VIRGIN ISLANDS, U.S.","CODE":"VI"},{"DESCRIPTION":"WALLIS AND FUTUNA","CODE":"WF"},{"DESCRIPTION":"WESTERN SAHARA","CODE":"EH"},{"DESCRIPTION":"YEMEN","CODE":"YE"},{"DESCRIPTION":"ZAMBIA","CODE":"ZM"},{"DESCRIPTION":"ZIMBABWE","CODE":"ZW"}]
                // that.venues = res.venues
                resolve("ok")
            // }).catch((e) => reject(e))
        })
    }
}